import React from 'react'
import { EditableComponent } from '@adobe/aem-react-editable-components'
import {
  SliderThemes,
  getColumnWidth,
  ContainerPaddings,
  SliderNavigationPositions,
  useThemeUtils
} from '@dcxwam/dcx-wam-ui-foundations'
import { slidesArray } from '../Slides/Slides'
import { canUseDom } from '../../../../utils/isSsr'
import { EditableComponentPropsType } from '../../../../utils/prop-types'
import { SliderVariantProps } from '../types'
import withComponentRefresh from '../../../../utils/aem/editor/withComponentRefresh'
import { useExtractEditableProps } from '../../../../utils/aem/editor/extractEditableProps'
import { NoSsr } from '../../../functional/NoSsr/NoSsr'
import { getSliderComponent } from '../common/getSliderComponent'
import {
  withErrorBoundary,
  ErrorFallback
} from '../../../functional/ErrorBoundary'

if (canUseDom) {
  import('@dcxwam/dcx-wam-ui-foundations/css')
}

const SliderVariantA: React.FC<EditableComponentPropsType<SliderVariantProps>> =
  withComponentRefresh((props) => {
    const {
      accessibilityFirst,
      accessibilityLast,
      accessibilityNext,
      accessibilityPrevious,
      id,
      background,
      adaptiveHeight,
      theme,
      xfPath,
      ...rest
    } = props.model
    const editableProps = useExtractEditableProps(props, rest)

    const themeUtils = useThemeUtils()

    const slides = slidesArray(props)

    let sliderATheme = SliderThemes.Light
    switch (theme) {
      case 'light':
        sliderATheme = SliderThemes.Light
        break
      case 'dark':
        sliderATheme = SliderThemes.Dark
        break
      default:
        break
    }

    const configSliderA = {
      className: 'slider-a',
      navigationPosition: SliderNavigationPositions.Mid,
      slideToClickedSlide: true,
      background,
      centeredSlides: true,
      slides,
      sliderTheme: sliderATheme,
      lazyLoading: true,
      keyboard: true,
      autoHeight: adaptiveHeight,
      numberOfColumns: themeUtils.getResponsiveProp([
        getColumnWidth(10, 12),
        getColumnWidth(10, 12),
        getColumnWidth(8, 12)
      ]),
      propsPerBreakpoints: themeUtils.getResponsiveProp([
        {
          slidesPerView: 1,
          spaceBetween: Number(themeUtils.getComputedSpacing(Number(3), true))
        },
        {
          slidesPerView: 1,
          spaceBetween: Number(themeUtils.getComputedSpacing(Number(3), true))
        },
        {
          slidesPerView: 1,
          spaceBetween: Number(themeUtils.getComputedSpacing(Number(5), true))
        }
      ]),
      sliderPadding: themeUtils.getResponsiveProp([
        { l: ContainerPaddings.Size_0 }
      ]),
      accessibilityProps: {
        firstSlideMessage: accessibilityFirst,
        lastSlideMessage: accessibilityLast,
        prevSlideMessage: accessibilityPrevious,
        nextSlideMessage: accessibilityNext
      }
    }

    const componentToDisplay = getSliderComponent({
      props,
      xfPath,
      sliderConfig: configSliderA
    })

    return (
      <NoSsr>
        <EditableComponent {...editableProps}>
          {componentToDisplay}
        </EditableComponent>
      </NoSsr>
    )
  })

const SliderVariantAWithErrorBoundary = withErrorBoundary(SliderVariantA, {
  componentName: 'SliderVariantA',
  fallback: <ErrorFallback componentName="SliderVariantA" />
})

export default SliderVariantAWithErrorBoundary
